import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteCards } from "../../../redux/slices/user";
import { Spinner } from "react-bootstrap";

const DeleteCard = (props) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const handleDeleteUser = () => {
    let params = {
      paymentMethodId: props.cardId,
    };
    setLoading(true);
    dispatch(
      deleteCards({
        ...params,
        cb(res) {
          if (res?.data) {
            setLoading(false);
            props.closeModal();
            props.refreshData();
          } else {
          }
        },
      })
    );
  };
  return (
    <div className="py-3">
      <h5 className="font-28 text-center">
        Are you Sure you want to delete the Card ?
      </h5>
      <p className="text text-center py-3">
        You are about to delete the card. You won't be able to undo this.
      </p>
      <div className="row justify-content-center mt-4">
        <div className="d-grid gap-1 col-lg-3 col-md-6">
          <button
            className="primaryBtn submitBtn m-0"
            type="button"
            onClick={(e) => handleDeleteUser(e)}
          >
            <span>Yes, Delete</span>
            {loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                className="ms-1"
                aria-hidden="true"
              />
            )}{" "}
          </button>
        </div>
        <div className="d-grid gap-1 col-lg-3 col-md-6">
          <button
            className="primaryBtn cancelBtn m-0"
            onClick={(e) => props.closeModal()}
          >
            <span>No, Cancel</span>
          </button>
        </div>
      </div>
    </div>
  );
};
export default DeleteCard;
